import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

import CustomCheckbox from 'Pods/Shared/Checkbox/CustomCheckbox'
import InputField from 'Pods/Shared/InputField'

function CgiModelDetails({ handleDetailChange, cgTechDetails }) {
  const details = [
    { title: 'Textures', slug: 'textures', hasSeparatorAfter: false },
    { title: 'Materials', slug: 'materials', hasSeparatorAfter: true },
    { title: 'Animated', slug: 'animated', hasSeparatorAfter: false },
    { title: 'Rigged', slug: 'rigged', hasSeparatorAfter: true },
    { title: 'Low-poly (game-ready)', slug: 'lowPoly', hasSeparatorAfter: false },
    { title: 'PBR', slug: 'pbr', hasSeparatorAfter: true },
    { title: 'UVW mapping', slug: 'uvwMapping', hasSeparatorAfter: true },
    { title: 'Plugins used', slug: 'pluginsUsed', hasSeparatorAfter: false },
  ]

  return (
    <Fragment>
      <div className="technical-details-area__checkboxes">
        {details.map((detail, index) => (
          <Fragment key={detail.slug}>
            <CustomCheckbox
              text={detail.title}
              name={detail.slug}
              customClass={!detail.hasSeparatorAfter && index !== details.length - 1 ? 'u-mr10' : ''}
              onTrigger={handleDetailChange}
              isChecked={cgTechDetails[detail.slug]}
            />
            {detail.hasSeparatorAfter && <span className="separator" />}
          </Fragment>
        ))}
      </div>

      <div className="row">
        <div className="col-12 col-sm-10 col-md-8">
          <div className="row">
            <div className="col-12 col-sm-6 unwrapped-uvs__title">
              <div className="section-heading--small u-mt10">Unwrapped UVs</div>
            </div>
            <div className="col-12 col-sm-6 geometry__title">
              <div className="section-heading--small u-mt10">Geometry</div>
            </div>
            <div className="col-12 col-sm-6 unwrapped-uvs__select">
              <Select
                id="unwrapped-uvs"
                className="Select-outline"
                placeholder="Choose value"
                options={[{ label: 'Choose value', value: null }].concat(I18n.translate('publisher.unwrapped_uvs'))}
                onChange={(data) => handleDetailChange('unwrappedUvs', data.value)}
                value={cgTechDetails.unwrappedUvs}
                searchable={false}
                clearable={false}
                disabled={!cgTechDetails.uvwMapping}
              />
              <span className="separator separator--absolute" />
            </div>
            <div className="col-12 col-sm-6 geometry__select">
              <Select
                id="geometry-type"
                className="Select-outline"
                placeholder="Choose geometry"
                options={I18n.translate('publisher.geometry_types')}
                onChange={(data) => handleDetailChange('geometryType', data.value)}
                value={cgTechDetails.geometryType}
                searchable={false}
                clearable={false}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

CgiModelDetails.propTypes = {
  handleDetailChange: PropTypes.func.isRequired,
  cgTechDetails: PropTypes.shape({
    textures: PropTypes.bool.isRequired,
    materials: PropTypes.bool.isRequired,
    animated: PropTypes.bool.isRequired,
    rigged: PropTypes.bool.isRequired,
    lowPoly: PropTypes.bool.isRequired,
    pbr: PropTypes.bool.isRequired,
    uvwMapping: PropTypes.bool.isRequired,
    pluginsUsed: PropTypes.bool.isRequired,
    unwrappedUvs: PropTypes.string,
    geometryType: PropTypes.string,
  }).isRequired,
}

export default CgiModelDetails
